import React, { useState, useEffect, Fragment, forwardRef, useRef } from "react";
import { Row, Col, Label, Input, Form, FormGroup, Button, Card } from "reactstrap";

import { useForm } from "react-hook-form";
import Dropzone from "react-dropzone-uploader";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { mykyc } from "../../../../../redux/kyc/action";
import RequiredIndicator from "../../../../partial/RequiredIndicator";
import { submitKyc, updateDealerDetails, validatePanCard } from "../../../../../api";
import {
  getFromLocalStorage,
  setInLocalStorage,
} from "../../../../../hooks/useLocalStorage";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import validateFile from "../../../../../utilities/validateFile";
import handleupload from "../../../../../utilities/handleUpload";
import PDFViewer from "../../../../../utilities/PDFViewer";
import { kycInitialState } from "../../../../../redux/kyc/reducer";
import { Edit, InfoOutlined } from "@mui/icons-material";
import FileUploadComponent from "../../../../common/FileUpload";
import KycViewNote from "../../kyc_note/KycViewNote";
import KycEditNote from "../../kyc_note/KycEditNote";
import specialCharacterConstrains from "../../../../../utilities/specialCharacterConstrains";

const Aadhar = (props, ref) => {
  const {
    activeStep,
    setActiveStep,
    setStep3Valid,
    dealerKycData,
    is_kyc_submitted,
    is_kyc_active,
    isUpdated
  } = props;
  const dispatch = useDispatch();
  const kycData = useSelector((state) => state.Kyc);
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const {
    handleSubmit,
    register,
    setValue,
    trigger,
    errors,
    setError,
    getValues,
  } = useForm();
  const [aadharfileUrl, setAadharFileUrl] = useState("");
  const [panfileUrl, setPanFileUrl] = useState("");
  const [supportingDocfileUrl, setSupportingDocFileUrl] = useState("");
  const [aadharfileUploadFlag, setAadharFileUploadFlag] = useState(false);
  const [panfileUploadFlag, setPanFileUploadFlag] = useState(false);
  const [supportingDocfileUploadFlag, setSupportingDocFileUploadFlag] =
    useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [originalValues, setOriginalValues] = useState({});
  const kycDataRef =  useRef(useSelector((state) => state.Kyc))


  useEffect(() => {
    async function checkDetails() {
      const storedData = kycData.authorizedSignatory;
      Object.keys(storedData).forEach((fieldName) => {
        setValue(fieldName, storedData[fieldName]);
      });
      setAadharFileUrl(getValues()["signatory_aadhar_image"]);
      setPanFileUrl(getValues()["signatory_pan_image"]);
      setSupportingDocFileUrl(getValues()["supporting_doc"]);
    }
    checkDetails();
  }, []);

  const handleBack = () => {
    if (is_kyc_submitted) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      const rhfdata = getValues();
      dispatch(
        mykyc({
          ...kycData,
          authorizedSignatory: { ...kycData.authorizedSignatory, ...rhfdata },
          txnid: Date.now(),
        })
      );
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  // useEffect(() => {
  //   kycData = kycDataRef
  // },[isUpdated])

  const submitForm = async (data) => {
    setLoading(true);
    const panData = {
      dealer_pan_card_number: kycData?.panCard?.dealer_pan_card_number?.toUpperCase(),
      dealer_pan_card_name: kycData?.panCard?.dealer_pan_card_name,
      dealer_pan_card_image: kycData?.panCard?.dealer_pan_card_image,
    }
    const gstData = { gstn_state: kycData?.gstn?.gstn_state, gstn_pincode: kycData?.gstn?.gstn_pincode,entity_type: kycData?.gstn?.entity_type, gstn_number: kycData?.gstn?.gstn_number?.toUpperCase(), gstn_account_name: kycData?.gstn?.gstn_account_name, gstn_image:kycData?.gstn?.gstn_image}
    const tanData =  {tan_card_number: kycData?.tan?.tan_card_number, tan_card_image:kycData?.tan?.tan_card_image}
    const bankdetailsData = { bank_account_number: kycData?.bankDetails?.bank_account_number, bank_account_name: kycData?.bankDetails?.bank_account_name, bank_name: kycData?.bankDetails?.bank_name, ifsc_code: kycData?.bankDetails?.ifsc_code, cancelled_cheque_number: kycData?.bankDetails?.cancelled_cheque_number, cancelled_cheque_image: kycData?.bankDetails?.cancelled_cheque_image, is_bank_details_verified: kycData?.bankDetails?.is_bank_details_verified }

    dispatch(
      mykyc({
        ...kycData,
        authorizedSignatory: { ...kycData.authorizedSignatory, ...data },
        txnid: Date.now(),
      })
    );
    // try {
    //   const panNSDLPayload = { panNumber: data.signatory_pan_number };
    //   await validatePanCard(panNSDLPayload);
    // } catch (error) {
    //   toast.error("NSDL:Invalid PAN Card details");
    //   setIsSubmitting(false);
    //   return;
    // }
    const finalPayloadFromRedux = {
      ...panData,
      ...gstData,
      ...tanData,
      ...bankdetailsData,
      ...data,
    };
    finalPayloadFromRedux.is_pan_verified = false;
    finalPayloadFromRedux.panNSDLVerify = false;
    finalPayloadFromRedux.is_gstn_verified = false;
    finalPayloadFromRedux.company_id = getFromLocalStorage("user")?.dealerInfo?.company_id;
    finalPayloadFromRedux.dealership_id = getFromLocalStorage("user")?.dealerInfo?.dealership_id;
    finalPayloadFromRedux.new_kyc_name = kycData?.gstn?.trade_name;

    console.log(finalPayloadFromRedux, "finalPayloadFromRedux");

    await submitKyc(finalPayloadFromRedux)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setInLocalStorage("user", {
            ...getFromLocalStorage("user"),
            dealerInfo: {
              ...getFromLocalStorage("user").dealerInfo,
              is_kyc_submitted: true,
            },
          });
          Swal.fire({
            icon: "success",
            title: "KYC documents submitted successfully!",
            text: `Please note the Ticket number for the request ${res.data.result.ticketNo}`,
          }).then(() => {
            setLoading(false);
            dispatch(mykyc(kycInitialState));
            navigate("/requests/my-requests");
          });
        }
      })
      .catch((err) => {
        console.log(err, "err");
        toast.error("Invalid Details");
        setLoading(false)
      });
  };

  const updateAadharDetails = async (data) => {
    setLoading(true);
    try {
      const dealership_id = getFromLocalStorage("user")?.dealerInfo?.dealership_id;
      const kycId = getFromLocalStorage("user")?.dealerInfo?.dealership_kyc_detail.kyc_id;
      const dealerMail = getFromLocalStorage("user")?.dealerInfo?.email;
      const userMail = getFromLocalStorage("user")?.email;
      const userName = getFromLocalStorage("user")?.name;
      const isAuthSignatoryUpdate = true;
      // const isBankDetailsUpdate = false;


      const commonData = { dealership_id, kycId, dealerMail, userMail, userName, isAuthSignatoryUpdate };
      const updateField = data;

      const payload = { updateField, commonData };
      const updateDetails = await updateDealerDetails(payload);

      setLoading(false);
      if (updateDetails.status === 200) {
        await Swal.fire({
          icon: 'success',
          title: 'Updated Successfully',
          text: updateDetails.data.result.message,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const handleEditSave = async (data) => {
    const changedFields = Object.keys(data).reduce((acc, key) => {
      if (data[key] === undefined) return acc;
      if (String(data[key] ?? '') !== String(originalValues[key] ?? '')) {
        acc[key] = data[key];
      }
      return acc;
    }, {});

    if (Object.keys(changedFields).length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Changes',
        text: 'You have not made any changes.',
      });
      return;
    }

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to update the authorized signatory details?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      await updateAadharDetails(changedFields);
      setIsEditing(false);
    }
  };

  return (
    <Fragment>

      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.4)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div className="spinner-border text-light" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}

      <Row>
        <Col xl="12" md="12" sm="12" className="mt-4" key={1}>
          <div className="project-box">
            {is_kyc_active ? (
              <span className={`badge badge-success`}>{"Verified"}</span>
            ) : (
              ""
            )}

            <div className="mt-3">
              {(is_kyc_submitted || is_kyc_active) ? (
                <>
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Aadhar Card Number"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <Input
                          className="form-control"
                          name="signatory_aadhar_number"
                          type="text"
                          defaultValue={kycData?.authorizedSignatory?.signatory_aadhar_number}
                          readOnly={!isEditing}
                          innerRef={isEditing ? register(specialCharacterConstrains(true, "Aadhar Number is required", { minLength: { value: 12, message: "Aadhar Number should be 12 digits" } })) : undefined}
                          onKeyPress={isEditing ? (event) => {
                            if (!/[0-9]/.test(event.key)) event.preventDefault();
                            if (event.target.value.length >= 12) event.preventDefault();
                          } : undefined}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.signatory_aadhar_number?.message}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Name on Aadhar Card"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <Input
                          className="form-control"
                          name="signatory_aadhar_name"
                          type="text"
                          defaultValue={kycData?.authorizedSignatory?.signatory_aadhar_name}
                          readOnly={!isEditing}
                          innerRef={isEditing ? register(specialCharacterConstrains(true, "Name on Aadhar is required")) : undefined}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.signatory_aadhar_name?.message}</span>}
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className="text-center">
                        <Label>{"Aadhar Document"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <FileUploadComponent
                          name="signatory_aadhar_image"
                          fileUploadFlag={false}
                          data={kycData?.authorizedSignatory?.signatory_aadhar_image}
                          viewOnly={!isEditing}
                          register={isEditing ? register : undefined}
                          setValue={isEditing ? setValue : undefined}
                          trigger={isEditing ? trigger : undefined}
                          getValues={isEditing ? getValues : undefined}
                          add={isEditing ? (getValues()["signatory_aadhar_image"]?.length > 0 ? false : true) : undefined}
                          pdfImageOnly={isEditing ? true : undefined}
                          required={false}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.signatory_aadhar_image && "Signatory Aadhar Image is required"}</span>}
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6">
                      <Row>
                        <Col xl="12" md="12">
                          <FormGroup>
                            <Label>{"PAN Card Number"}</Label>
                            {isEditing && <RequiredIndicator />}
                            <Input
                              className="form-control"
                              name="signatory_pan_number"
                              type="text"
                              defaultValue={kycData?.authorizedSignatory?.signatory_pan_number}
                              readOnly={!isEditing}
                              innerRef={isEditing ? register({
                                required: "PAN number is required",
                                pattern: { value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, message: "PAN number format is wrong" },
                              }) : undefined}
                            />
                            {isEditing && <span style={{ color: "red" }}>{errors.signatory_pan_number?.message}</span>}
                          </FormGroup>
                          <FormGroup>
                            <Label>{"Name on PAN Card"}</Label>
                            {isEditing && <RequiredIndicator />}
                            <Input
                              className="form-control"
                              name="signatory_pan_name"
                              type="text"
                              defaultValue={kycData?.authorizedSignatory?.signatory_pan_name}
                              readOnly={!isEditing}
                              innerRef={isEditing ? register(specialCharacterConstrains(true, "Pan name is required")) : undefined}
                            />
                            {isEditing && <span style={{ color: "red" }}>{errors.signatory_pan_name?.message}</span>}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className="text-center">
                        <Label>{"PAN document"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <FileUploadComponent
                          name="signatory_pan_image"
                          data={kycData?.authorizedSignatory?.signatory_pan_image}
                          viewOnly={!isEditing}
                          register={isEditing ? register : undefined}
                          setValue={isEditing ? setValue : undefined}
                          trigger={isEditing ? trigger : undefined}
                          getValues={isEditing ? getValues : undefined}
                          add={isEditing ? (getValues()["signatory_pan_image"]?.length > 0 ? false : true) : undefined}
                          pdfImageOnly={isEditing ? true : undefined}
                          required={false}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.signatory_pan_image && "Signatory Pan Image is Required"}</span>}
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Relationship with Entity (Dealership)"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <Input
                          className="form-control"
                          name="signatory_relationship"
                          defaultValue={kycData?.authorizedSignatory?.signatory_relationship}
                          type="text"
                          readOnly={!isEditing}
                          innerRef={isEditing ? register(specialCharacterConstrains(true, "Relationship with Entity is required")) : undefined}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.signatory_relationship?.message}</span>}
                      </FormGroup>
                      <FormGroup style={{ textAlign: "center" }}>
                        <div className="form-check">
                          <div className="checkbox pl-10">
                            <Input
                              id="invalidCheck"
                              name="insureCheckbox"
                              type="checkbox"
                              defaultChecked={is_kyc_submitted}
                              readOnly={!isEditing}
                              innerRef={isEditing ? register({ required: true }) : undefined}
                            />
                            <Label htmlFor="invalidCheck">
                              {"I ensure the Uploaded documents represent accurate information"}
                            </Label>
                            {isEditing && <span style={{ color: "red" }}>{errors.insureCheckbox && "You must agree before submitting"}</span>}
                          </div>
                        </div>
                      </FormGroup>
                      <KycViewNote />
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      {/* <FormGroup style={{ textAlign: "center" }}>
                        {kycData?.authorizedSignatory?.supporting_doc?.endsWith(".pdf") ? (
                          <div>
                            <PDFViewer pdfUrl={kycData?.authorizedSignatory?.supporting_doc} />
                          </div>
                        ) : (
                          <div class="img-item">
                            <a
                              href={kycData?.authorizedSignatory?.supporting_doc}
                              target="_blank"
                            >
                              <img
                                className="img-thumbnail img-fluid kyc-document"
                                src={kycData?.authorizedSignatory?.supporting_doc}
                                alt="Dealer Pan Card"
                              />
                            </a>
                          </div>
                        )}
                      </FormGroup> */}
                      <FormGroup className="text-center">
                        <Label>{"Supporting document"}</Label>
                        {isEditing && <RequiredIndicator />}
                        <FileUploadComponent
                          name="supporting_doc"
                          fileUploadFlag={false}
                          data={kycData?.authorizedSignatory?.supporting_doc}
                          viewOnly={!isEditing}
                          register={isEditing ? register : undefined}
                          setValue={isEditing ? setValue : undefined}
                          trigger={isEditing ? trigger : undefined}
                          getValues={isEditing ? getValues : undefined}
                          add={isEditing ? (getValues()["supporting_doc"]?.length > 0 ? false : true) : undefined}
                          pdfImageOnly={isEditing ? true : undefined}
                          required={false}
                        />
                        {isEditing && <span style={{ color: "red" }}>{errors.supporting_doc && "Supporting Document is required"}</span>}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto" className="d-flex gap-2">
                      {isEditing ? (
                        <>
                          <Button type="button" color="secondary" onClick={() => setIsEditing(false)} className="mr-2">
                            Cancel
                          </Button>
                          <Button type="button" color="success" onClick={handleSubmit(handleEditSave)} disabled={loading}>
                            Submit
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button type="button" color="warning" onClick={() => { setOriginalValues({ ...kycData.authorizedSignatory, insureCheckbox: is_kyc_submitted }); setIsEditing(true); }} className="mr-2">
                            <Edit fontSize="small" /> Edit
                          </Button>
                          {!is_kyc_submitted && (
                            <Button type="button" color="success">
                              Submit
                            </Button>
                          )}
                        </>
                      )}
                    </Col>
                  </Row>
                </>
              ) : getFromLocalStorage("ROLE")?.key == "DEALERSHIP_MANAGER" && (
                <Form
                  className="form-bookmark needs-validation"
                  onSubmit={handleSubmit(submitForm)}
                >
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Aadhar Card Number"}</Label>{" "}
                        <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="signatory_aadhar_number"
                          type="text"
                          defaultValue={getValues()["signatory_aadhar_number"]}
                          innerRef={register(specialCharacterConstrains(true, "Aadhar Number is required", {
                            minLength: {
                              value: 12, // Define the minimum length here
                              message: "Aadhar Number should be 12 digits",
                            }
                          }))}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                            if (event.target.value.length >= 12) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <span style={{ color: "red" }}>
                          {errors.signatory_aadhar_number && (
                            <span>
                              {errors.signatory_aadhar_number.message}
                            </span>
                          )}
                        </span>
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Name on Aadhar Card"}</Label>{" "}
                        <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="signatory_aadhar_name"
                          type="text"
                          innerRef={register(specialCharacterConstrains(true, "Name on Aadhar is required"))}
                          defaultValue={getValues()["signatory_aadhar_name"]}
                        />
                        <span style={{ color: "red" }}>
                          {errors.signatory_aadhar_name?.message}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup style={{ textAlign: "center" }}>
                        <Label>{"Aadhar Document"}</Label> <RequiredIndicator />
                        {/* <Dropzone
                          onChangeStatus={({ meta, file }, status) =>
                            handleupload(
                              { meta, file },
                              status,
                              "signatory_aadhar_image",
                              aadharfileUploadFlag,
                              setValue,
                              trigger
                            )
                          }
                          maxFiles={1}
                          multiple={false}
                          canCancel={false}
                          inputContent={
                            aadharfileUrl ? (
                                <div style={{ position: 'relative' }}>
                                                                <img style={{ width: '50%', height: '40%' }} src={aadharfileUrl} alt="Upload Aadhar document" />
                                                                <h1 style={{ position: 'absolute', top: 0, right: 60, margin: '10px' }}><Edit/></h1>
                                                              </div>
                            ) : (
                              <span>Upload Image</span>
                            )
                          }
                          accept=".pdf, image/*"
                          styles={{
                            dropzone: { width: "100%", height: 50 },
                            dropzoneActive: { borderColor: "green" },
                            inputLabel: { fontSize: "10px" },
                          }}
                          {...register("signatory_aadhar_image", {
                            validate: {
                              required: (file) => {
                                if (!aadharfileUploadFlag) {
                                  if (!getValues()["signatory_aadhar_image"]) {
                                    return "File is required.";
                                  }
                                }
                              },
                            },
                          })}
                          validate={(file) =>
                            validateFile(
                              file,
                              "signatory_aadhar_image",
                              setAadharFileUploadFlag,
                              setError
                            )
                          }
                        /> */}
                        <FileUploadComponent
                      register={register}
                      name="signatory_aadhar_image"
                      setValue={setValue}
                      trigger={trigger}
                      getValues={getValues}
                      data={aadharfileUrl}
                      add={getValues()["signatory_aadhar_image"]?.length > 0 ? false : true}
                      pdfImageOnly={true}
                    />
                        <span style={{ color: "red" }}>
                          {errors.signatory_aadhar_image && (
                            <span>Signatory Aadhar Image is required</span>
                          )}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6">
                      <Row>
                        <Col xl="12" md="12">
                          <FormGroup>
                            <Label>{"PAN Card Number"}</Label>{" "}
                            <RequiredIndicator />
                            <Input
                              className="form-control"
                              name="signatory_pan_number"
                              type="text"
                              defaultValue={getValues()["signatory_pan_number"]}
                              innerRef={register({
                                required: "PAN number is required",
                                pattern: {
                                  value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                                  message: "PAN number format is wrong",
                                },
                              })}
                            />
                            <span style={{ color: "red" }}>
                              {errors.signatory_pan_number && (
                                <span>
                                  {errors.signatory_pan_number.message}
                                </span>
                              )}
                            </span>
                          </FormGroup>
                          <FormGroup>
                            <Label>{"Name on PAN Card"}</Label>{" "}
                            <RequiredIndicator />
                            <Input
                              className="form-control"
                              name="signatory_pan_name"
                              type="text"
                              innerRef={register(specialCharacterConstrains(true, "Pan name is required"))}
                              defaultValue={getValues()["signatory_pan_name"]}
                            />
                            <span style={{ color: "red" }}>
                              {errors.signatory_pan_name?.message}
                            </span>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup style={{ textAlign: "center" }}>
                        <Label>{"PAN document"}</Label> <RequiredIndicator />
                       
                        <FileUploadComponent
                            register={register}
                            name="signatory_pan_image"
                            setValue={setValue}
                            trigger={trigger}
                            getValues={getValues}
                            data={panfileUrl}
                            add={getValues()["signatory_pan_image"]?.length > 0 ? false : true}
                            pdfImageOnly={true}
                          />
                        <span style={{ color: "red" }}>
                          {errors.signatory_pan_image && (
                            <span>Signatory Pan Image is Required</span>
                          )}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Relationship with Entity (Dealership)"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="signatory_relationship"
                          type="text"
                          placeholder="eg. Owner"
                          innerRef={register(specialCharacterConstrains(true, "Relationship with Entity is required"))}
                        />
                        <span style={{ color: "red" }}>
                          {errors.signatory_relationship?.message}
                        </span>
                      </FormGroup>
                      <FormGroup style={{ textAlign: "center" }}>
                        <div className="form-check">
                          <div className="checkbox pl-10">
                            <Input
                              id="invalidCheck"
                              name="insureCheckbox"
                              type="checkbox"
                              // innerRef={register()}
                              innerRef={register({ required: true })}
                              // checked={is_kyc_submitted}
                            />
                            <Label htmlFor="invalidCheck">
                              {
                                "I ensure the Uploaded documents represent accurate information"
                              }
                            </Label>

                            <span style={{ color: "red" }}>
                              {errors.insureCheckbox &&
                                "You must agree before submitting"}
                            </span>
                          </div>
                        </div>
                      </FormGroup>
                      <KycEditNote />
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup style={{ textAlign: "center" }}>
                        <Label>{"Supporting Document"}</Label>{" "}
                        <RequiredIndicator />
                        <FileUploadComponent register={register} name="supporting_doc" fileUploadFlag={supportingDocfileUploadFlag} setValue={setValue} trigger={trigger} getValues={getValues} data={supportingDocfileUrl} add={getValues()["supporting_doc"]?.length > 0 ? false : true} pdfImageOnly={true} />
                        <span style={{ color: "red" }}>
                          {errors.supporting_doc && (
                            <span>Supporting Document is required</span>
                          )}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          &lt;&lt; Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto">
                      {!is_kyc_active && (
                        <Button type="submit" color="success" disabled={loading}>
                          {loading ? "Loading..." : "Submit"}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Aadhar;
